import { Pipe, PipeTransform } from '@angular/core';
import { StoreViewModel } from '@models/api.models';

type allowedProperties = Pick<
    StoreViewModel,
    'hideStoreStocks' | 'isOpenRightNow' | 'pickupInStore' | 'reserveInStore'
>;

@Pipe({
    name: 'filterStoresByFlag',
    standalone: true
})
export class FilterStoresByFlagPipe implements PipeTransform {
    transform(stores: StoreViewModel[] | null, property: keyof allowedProperties, bool: boolean): StoreViewModel[] {
        if (!stores) {
            return [];
        }
        return stores.filter(store => store[property] === bool);
    }
}
